import React from "react";
import "./rating.css";

const Rating = ({ rating, totalRatings }) => {
  if (!rating || rating === "0") return null;

  return (
    <div className="flex flex-col rounded-[10px] overflow-hidden border border-white/10 min-w-[52px] shadow-xl">
      <div className="bg-[#148016] py-[6px] px-2 flex items-center justify-center gap-1.5">
        <span className="text-white font-bold text-[16px] leading-none">
          {parseFloat(rating).toFixed(1)}
        </span>
        <span className="text-white text-[16px] leading-none">★</span>
      </div>
      <div className="bg-[#212121] py-[2px] px-2 text-center border rounded-b-lg border-white/20">
        <span className="text-white/80 text-[14px] font-bold leading-none tracking-wide">
          {totalRatings || "552"}
        </span>
      </div>
    </div>
  );
};

export default Rating;
